export const handleFormCompetition = () => {

	var validateFields = {};
	const submitButton = document.getElementById('Form').querySelector('input[type=submit]');
	
	let liveValidation = e => {
		var ve = e.target;
		switch (ve.getAttribute('name')) {
			case 'imie':
			case 'nazwisko':
			case 'miasto':
				if (ve.value.length < 2 || ve.value.length > 120) {
					ve.parentNode.classList.add('__jsErr');
					delete validateFields[ve.getAttribute('name')];
				} else {
					ve.parentNode.classList.remove('__jsErr')
					validateFields[ve.getAttribute('name')] = 1;
				}
				break;
			case 'opis':
				if (ve.value.length < 2 || ve.value.length > 400) {
					ve.parentNode.classList.add('__jsErr');
					delete validateFields[ve.getAttribute('name')];
                    ve.parentNode.classList.remove('__jsCorr');
				} else {
					ve.parentNode.classList.remove('__jsErr');
					validateFields[ve.getAttribute('name')] = 1;
                    ve.parentNode.classList.add('__jsCorr');
				}
				break;
			case 'email':
				if (!ve.value.toLowerCase().match(
					/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
					ve.parentNode.classList.add('__jsErr');
					delete validateFields[ve.getAttribute('name')];
				} else {
					ve.parentNode.classList.remove('__jsErr');
					validateFields[ve.getAttribute('name')] = 1;
				}
				break;
			case 'zgoda1':
			case 'zgoda2':
				if (ve.checked) {
                    ve.parentNode.classList.remove('__jsErr');
                    ve.parentNode.classList.add('__jsCorr');
					validateFields[ve.getAttribute('name')] = 1;                    
				} else {
					delete validateFields[ve.getAttribute('name')];
                    ve.parentNode.classList.add('__jsErr');
                    ve.parentNode.classList.remove('__jsCorr');
				}
				break;
		}

		if (Object.keys(validateFields).length >= 7) {
			submitButton.disabled = false;
		} else {
			submitButton.disabled = true;
		}
	}

	document.getElementById('Form').querySelectorAll('input, textarea').forEach(element => {
		element.addEventListener('change', liveValidation);
		//element.addEventListener('keyup', liveValidation);
		//element.addEventListener('click', liveValidation);
	});
	document.getElementById('Form').querySelectorAll('textarea').forEach(element => {
        element.addEventListener('keyup', e => {
            const len = e.target.value.length;
		    document.querySelector('.counter_value').innerHTML = len;
            if (len < 2 || len > 400) {            
                document.querySelector('.counter_value').classList.add('__jsErr')            
            } else {
                document.querySelector('.counter_value').classList.remove('__jsErr')
            }

        });
        
		
	});

	//wysłanie formularza na kliknięcie submita
	submitButton.addEventListener('click', e => {
		e.preventDefault();

		let formData = new FormData();
		document.getElementById('Form').querySelectorAll('input, textarea').forEach(element => {
			formData.append(element.name, element.value);
		});

		const url = document.getElementById('Form').getAttribute('data-url');
		fetch(url, {
			method: 'POST',
			body: formData
		})
			.then((response) => response.text())
			.then((html) => {

				document.getElementById('Response').style.display = 'flex';
				document.getElementById('Response').innerHTML = html;
                // append html-a zwrotnego 
				console.log('resp: ', html );
				document.querySelector('.sekcja_konkurs__form').classList.add('__jsResponse');
				// setTimeout(() => {
				// 	document.getElementById('Response').style.display = 'none';
				// 	document.getElementById('Response').innerHTML = '';
				// 	document.querySelector('.sekcja_konkurs__form').classList.remove('.__jsResponse');
				// }, "1000");
				const eventType =  e.pointerType === "mouse" ? 'click' : 'tap';
				
				window.dataLayer.push({
					event: 'site_interaction',
					eventCategory: 'send_form',
					moduleName: 'formularz_konkursowy1',
					eventAction: eventType
				});
				
			})
			.catch((err) => {
				document.getElementById('Response').innerHTML = html;
				// console.log('Error', err);
			});
	});
	
	

};

if(document.getElementById('Form')) {
	handleFormCompetition();
}
